import {
    fetchOffers,
    fetchOffersSelected,
    fetchOffers2,
    reset
}  from "../components/offers/store/actions"

module.exports = {
    fetchOffers,
    fetchOffersSelected,
    fetchOffers2,
    reset
};
